import * as _ from 'lodash'
const colorHex = {}
export const coloresUnique = (products, colors) => {
    for (let i = 0; i < colors.length; i++) {
        const color = colors[i];
        colorHex[color.Name] = color.Hex
    }
    const coloresAll = []
    for (let i = 0; i < products.length; i++) {
        if (products[i].Color !== '') {
            coloresAll.push({ nombre: products[i].Color, hex: colorHex[products[i].Color] })
        }
    }
    let distinct = _.uniqBy(coloresAll, 'nombre');
    let distinctOrder = distinct.sort(function (a, b) {
        return a.nombre.localeCompare(b.nombre);
    });
    return distinctOrder
}